import React from 'react';

import CustomDropdownWidget from './CustomDropdownWidget';

export const FullWidthFilterDropdownWidget = (params) => (
  <CustomDropdownWidget {...params} fullWidthFilterMenu />
);

export default FullWidthFilterDropdownWidget;
